import {Project} from "../interfaces/Project";
import axiosService from "./axiosService";
import {Response} from "../interfaces/Response";

const API_APPS_URL = process.env.REACT_APP_API_APPS_URL;
const API_DPE_URL = process.env.REACT_APP_API_DPE_URL;
const API_ERROR_URL = process.env.REACT_APP_API_ERROR_URL;

// Fonction pour récupérer tous les projets
export const getPlanactions = async (): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/projects/planactions`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des plans d\'actions', error);
        throw error;
    }
};

export const getProjects = async (): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/projects`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des projets', error);
        throw error;
    }
};

export const getErrorsNotVerify = async (): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_ERROR_URL}/api/error/nonverifier`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des erreurs', error);
        throw error;
    }
};

export const verifyErrorLog = async (id: number): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.post(`${API_ERROR_URL}/api/error/${id}/verifier`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
    } catch (error) {
        console.error(`Erreur lors de la suppression du projet ${id}`, error);
        throw error;
    }
};

export const getProject = async ( projectID : number): Promise<any> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/projects/` +  projectID,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des projets', error);
        throw error;
    }
};

export const getErrorIndicators = async (): Promise<any> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_ERROR_URL}/api/error/nonverifier/indicators`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des erreurs (Indicateur)', error);
        throw error;
    }
};



export const getVerificationAPE = async ( projectID : number): Promise<any> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/projects/` +  projectID + `/verificationape`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des projets', error);
        throw error;
    }
};

// Fonction pour créer un nouveau projet
export const createProject = async (project: Project): Promise<Project> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_APPS_URL}/api/projects/create/residentiel/` + project.numeroAdeme,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
                timeout: 180000
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la création du projet', error);
        throw error;
    }
};

// Fonction pour mettre à jour un projet existant
export const updateProject = async (id: number, project: Project): Promise<Project> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.put(`${API_APPS_URL}/api/projects/${id}`, project,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la mise à jour du projet ${id}`, error);
        throw error;
    }
};

// Fonction pour supprimer un projet
export const deleteProject = async (id: number): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_APPS_URL}/api/projects/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
    } catch (error) {
        console.error(`Erreur lors de la suppression du projet ${id}`, error);
        throw error;
    }
};

export const deletePlanaction = async (id: number): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_APPS_URL}/api/projects/planaction/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
    } catch (error) {
        console.error(`Erreur lors de la suppression du plan d'action ${id}`, error);
        throw error;
    }
};



export const exportExcelDPE = async (id: number, numeroDPE: string): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');

        // Requête pour télécharger le fichier Excel
        const response = await axiosService.post(`${API_APPS_URL}/api/projects/${id}/download/excel`,
            {},
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                responseType: 'blob',
            });

        if (response.data) {
            // Créer une URL pour le blob
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
            // Créer un élément <a> pour déclencher le téléchargement
            const a = document.createElement('a');
            a.href = url;
            a.download = `DPE_${numeroDPE}.xlsx`; // Nom du fichier à télécharger
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // Libérer l'objet URL pour éviter les fuites de mémoire
            window.URL.revokeObjectURL(url);
        } else {
            alert('Erreur lors du téléchargement du fichier');
        }

    } catch (error) {
        console.error(`Erreur lors de l'export du fichier Excel pour le projet ${id}`, error);
        throw error;
    }
};

export const exportTextVerificationAPE = async (id: number, numeroDPE: string): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');

        // Requête pour télécharger le fichier texte
        const response = await axiosService.post(`${API_APPS_URL}/api/projects/${id}/download/verificationape`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            responseType: 'blob',
        });

        if (response.data) {
            const fileBlob = new Blob([response.data], { type: 'text/plain' });

            const url = window.URL.createObjectURL(fileBlob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `verification_APE_${numeroDPE}.txt`; // Nom du fichier à télécharger
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        } else {
            alert('Erreur lors du téléchargement du fichier');
        }

    } catch (error) {
        console.error(`Erreur lors de l'export du fichier texte pour le projet ${id}`, error);
        throw error;
    }
};

export const exportTextTraceCalcul = async (projectID: number, numeroplanaction: string): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');

        // Requête pour télécharger le fichier texte
        const response = await axiosService.get(`${API_DPE_URL}/api/dpe/planaction/verification/calcul/${numeroplanaction}/download/texte`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            responseType: 'blob',
        });

        if (response.data) {
            const fileBlob = new Blob([response.data], { type: 'text/plain' });

            const url = window.URL.createObjectURL(fileBlob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Trace_Calcul_${numeroplanaction}_${projectID}.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        } else {
            alert('Erreur lors du téléchargement du fichier');
        }

    } catch (error) {
        console.error(`Erreur lors de l'export du fichier texte pour le plan d'action ${projectID}`, error);
        throw error;
    }
};



export const refreshInfoDPEFromProject = async (id: number): Promise<Project> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_APPS_URL}/api/projects/${id}/rafraichir`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
                timeout: 180000
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors du rafraichissement du projet', error);
        throw error;
    }
};

export const getCatalogs = async (): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_DPE_URL}/api/catalogue`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des catalogues', error);
        throw error;
    }
};

export const deleteCatalog = async (id: number): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_APPS_URL}/api/catalogue/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
    } catch (error) {
        console.error(`Erreur lors de la suppression du catalogue ${id}`, error);
        throw error;
    }
};

export const getFournisseurs = async (): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_DPE_URL}/api/catalogue/fournisseurs`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des fournisseurs', error);
        throw error;
    }
};

export const deleteFournisseur = async (id: number): Promise<void> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_APPS_URL}/api/catalogue/fournisseurs/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
    } catch (error) {
        console.error(`Erreur lors de la suppression du fournisseur ${id}`, error);
        throw error;
    }
};

export const generatePlanAction = async (projetID : number): Promise<Response> => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_APPS_URL}/api/projects/${projetID}/lancercalcul`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la génération des plans d\'actions', error);
        throw error;
    }
};

